// extracted by mini-css-extract-plugin
module.exports = {"newCode":"newCode--BKrxm"};